import { z } from 'zod';
import { ErrorResponseSchema, SuccessMessageSchema } from '../../common/base';

/**
 * Request param schema for notification ID
 * DELETE /api/notifications/[id]
 */
export const DeleteNotificationParamSchema = z.object({
  id: z.string({
    error: 'Invalid notification ID',
  }).min(1, 'Invalid notification ID'),
});

/**
 * Success response schema for deleting a notification
 */
export const DeleteNotificationSuccessSchema = SuccessMessageSchema;

/**
 * Combined response schema for delete notification endpoint
 * DELETE /api/notifications/[id]
 *
 * Discriminated union based on success field
 *
 * @example
 * ```typescript
 * const response = DeleteNotificationResponseSchema.parse(data);
 * if (response.success) {
 *   console.log('Message:', response.message);
 * } else {
 *   console.error('Error:', response.error);
 * }
 * ```
 */
export const DeleteNotificationResponseSchema = z.discriminatedUnion('success', [
  DeleteNotificationSuccessSchema,
  ErrorResponseSchema,
]);

export type DeleteNotificationParam = z.infer<typeof DeleteNotificationParamSchema>;
export type DeleteNotificationSuccess = z.infer<typeof DeleteNotificationSuccessSchema>;
export type DeleteNotificationResponse = z.infer<typeof DeleteNotificationResponseSchema>;
